import { lazy } from 'react';
import i18next from 'i18next';
import { authModules } from 'app/auth';
import enGB from '@locales/password/enGB';
import deAT from '@locales/password/deAT';

i18next.addResourceBundle('enGB', 'password', enGB);
i18next.addResourceBundle('deAT', 'password', deAT);

const ChipInfo = lazy(() => import('./ChipInfo'));

const ChipInfoConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	routes: [
		{
			path: '/chipinfo',
			element: <ChipInfo />,
			auth: authModules.notloggedin,
		}
	]
};

export default ChipInfoConfig;
